:host {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
    pointer-events: none;
    --zindex: calc(var(--zindex-base, 0) + var(--zindex-popover, 1000));
    z-index: calc(0 + 1000);
    z-index: var(--zindex);
}

::slotted(*) {
    --zindex-base: var(--zindex);
}

.backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
    z-index: 0;
    pointer-events: all;
}
